import { useSelector } from "react-redux";
import { useUserPermissions } from "@components/PermissionedComponents";

// The backend refuses notes to a player. This check hides the tab until `current_user` names a coach.
export const useCanViewNotes = (): boolean => {
    const permissions = useUserPermissions();
    const userType: string | undefined = useSelector(({ auth }: any) => auth.currentUser.user_type);
    return userType === "coach" && !!permissions?.ViewNotes;
};
